import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../../../stores/authStore'
import { RolesPage } from '../../../features/admin/RolesPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/roles')({
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (role !== 'admin') {
      throw redirect({ to: '/admin' })
    }
  },
  component: AdminRolesRoute,
})

/* ───── Route Component ───── */

function AdminRolesRoute() {
  return <RolesPage />
}
